export declare class Theme {
  public campusId: number;
  public id: number;
  public styleSettings: { [key: string]: string }
}